module.exports = __webpack_public_path__ + "img/T1D_rc-12.1013d542.png";